<ng-container *ngIf="visible">
    <div class="data-container" [ngClass]="[isDev ? 'padding-bottom' : 'none-padding-bottom']">
        <!-- <ng-container *ngTemplateOutlet="picker"></ng-container> -->
        <div class="setting-sticky">
            <!-- <div class="screen-name" [class.pickup]="isPickup">{{screenName}}</div> -->
            <div style="margin: auto;"></div>
            <button mat-button type="button" class="button-careconne" (click)="popupCareConnePicker()" [class.disabled]="disabledCareConneSend">
                ケアコネ
            </button>
            <button mat-button [skipLocationChange]="true"
                [routerLink]="['', { outlets: { edit: 'record-display-setting' } }]" [queryParamsHandling]="'preserve'"
                [replaceUrl]="true" type="button" class="button-setting" (click)="handleOpenDisplaySetting()">
                条件変更
            </button>
        </div>
        <ng-container>
            <ng-container *ngIf="renderData.length > 0;else none">
                <ul *ngIf="renderData.length > 0" class="daily-record-list">
                    <li *ngFor="let item of renderData">
                        <app-daily-record [data]="item" [sdate]="config?.sdate || ''" [edate]="config?.edate || ''"
                            [name]="item.objnm"></app-daily-record>
                    </li>
                </ul>
            </ng-container>
        </ng-container>
    </div>
    <button [ngClass]="[isDev ? 'margin-bottom' : 'none-margin-bottom']" mat-fab class="create" (click)="create()">記録作成</button>
</ng-container>

<ng-template #jibunkatte>
    <div class="header-sticky" id="name-header">
        <span>今日の自分記録一覧（自動記録）</span>
        <span>職員{{ stfnm }}</span>
    </div>
    <ng-container [ngTemplateOutlet]="picker"></ng-container>
</ng-template>

<ng-template #jibungaireta>
    <div class="header-sticky" id="name-header">
        <span>自分が入れた</span>
        <span>職員{{ stfnm }}</span>
    </div>
    <ng-container [ngTemplateOutlet]="picker"></ng-container>
</ng-template>

<ng-template #koru>
    <div class="header-sticky" id="name-header">
        <span>コール一覧（自動記録）</span>
        <span>全職員</span>
    </div>
    <div class="add">
        <mat-icon svgIcon="add"></mat-icon>
    </div>
    <ng-container [ngTemplateOutlet]="picker"></ng-container>
</ng-template>

<ng-template #picker>
    <div class="header-sticky date-picker">
        <div class="date-range-menu">
            <span>
                <app-calendar-nav [currentDate]="selectedSDate!" [isShowNextPrevBtn]="false" [color]="textWhite"
                    (currentDateChange)="onSDateChange($event)"></app-calendar-nav>
            </span>
            <span class="separator">~</span>
            <span>
                <app-calendar-nav [currentDate]="selectedEDate!" [isShowNextPrevBtn]="false" [color]="textWhite"
                    (currentDateChange)="onEDateChange($event)"></app-calendar-nav>
            </span>
        </div>
    </div>

</ng-template>

<ng-template #katteguai>
    <div class="header-sticky" id="name-header">
        <span>今日の記録一覧</span>

    </div>
    <ng-container [ngTemplateOutlet]="picker"></ng-container>
</ng-template>

<ng-template #hitoribunno>
    <div class="header-sticky text-center" id="name-header">
        <span>一人分の</span>

    </div>
    <ng-container [ngTemplateOutlet]="picker"></ng-container>
</ng-template>

<ng-template #none>
    <div class="data-container center" *ngIf="!(isLoading$ | async)">
        <p class="list-none">記録はありません</p>
    </div>
</ng-template>

<ng-container *ngIf="lazySpinner === true">
    <div class="spinner-container-sched" [class.preload]="groupDailys.length === 0">
        <mat-spinner diameter="40" aria-label="読み込み中"></mat-spinner>
    </div>
</ng-container>

<div #end class="end"></div>